<rask-fieldset-toggle
    [formGroup]="$any(control)"
    label="Lagerålder (Min-Max)"
    class="minmaxPanel"
    [defaultExpanded]="open"
    [nrOfSelectedFilters]="filterLength">
    <div class="w-100">
        <rask-input-number
            label="Lagerålder (Min-Max)"
            formControlName="min"
            class="minmax"></rask-input-number>
        <span class="splitter">-</span>
        <rask-input-number
            formControlName="max"
            class="minmax right-minmax"></rask-input-number>
    </div>
</rask-fieldset-toggle>